import request from '@/utils/sap-request'

// 销售发票明细报表
export const reportForm1 = (data) => {
  return request({
    url: 'sap/bc/ztpm/to_new_crm/transdata/forms01',
    method: 'POST',
    timeout: 3000 * 600,
    data
  })
}

// 销售发票明细报表精简版
export const reportFormSimple = (data) => {
  return request({
    url: 'sap/bc/ztpm/to_new_crm/transdata/forms01_simple',
    method: 'POST',
    timeout: 3000 * 600,
    data
  })
}

// 经销商开票情况统计表
export const reportForm2 = (data) => {
  return request({
    url: 'sap/bc/ztpm/to_new_crm/transdata/forms02',
    method: 'POST',
    data
  })
}

// 批条酒订单执行情况报表
export const reportForm3 = (data) => {
  return request({
    url: 'sap/bc/ztpm/to_new_crm/transdata/forms03',
    method: 'POST',
    data
  })
}

// 产品经销情况报表
export const reportForm4 = (data) => {
  return request({
    url: 'sap/bc/ztpm/to_new_crm/transdata/forms04',
    method: 'POST',
    data
  })
}

// 经销商年度计划量动态明细报表
export const reportForm5 = (data) => {
  return request({
    url: 'sap/bc/ztpm/to_new_crm/transdata/forms05',
    method: 'POST',
    data
  })
}

// 酒类销售公司各部门及子公司销售情况统计表
export const reportForm6 = (data) => {
  return request({
    url: 'sap/bc/ztpm/to_new_crm/transdata/forms06',
    method: 'POST',
    data
  })
}

// 各营销中心各省各品牌销售情况统计表
export const reportForm7 = (data) => {
  return request({
    url: 'sap/bc/ztpm/to_new_crm/transdata/forms07',
    method: 'POST',
    data
  })
}

// 酒类销售公司(含子公司、批条酒)各品牌销售情况表
export const reportForm8 = (data) => {
  return request({
    url: 'sap/bc/ztpm/to_new_crm/transdata/forms08',
    method: 'POST',
    data
  })
}

// 酒类销售公司(含子公司、批条酒)各品牌销售情况表2
export const reportForm9 = (data) => {
  return request({
    url: 'sap/bc/ztpm/to_new_crm/transdata/forms09',
    method: 'POST',
    data
  })
}

// 年度销售计划转移报表
export const reportForm10 = (data) => {
  return request({
    url: 'sap/bc/ztpm/to_new_crm/transdata/forms010',
    method: 'POST',
    data
  })
}

// 各中心总量变动报表
export const reportForm11 = (data) => {
  return request({
    url: 'sap/bc/ztpm/to_new_crm/transdata/forms011',
    method: 'POST',
    data
  })
}

// 各中心总量使用报表
export const reportForm12 = (data) => {
  return request({
    url: 'sap/bc/ztpm/to_new_crm/transdata/forms012',
    method: 'POST',
    data
  })
}

// 合同收录日期明细报表
export const reportForm13 = (data) => {
  return request({
    url: 'sap/bc/ztpm/to_new_crm/transdata/forms013',
    method: 'POST',
    data
  })
}

// 经销商排名报表
export const reportForm14 = (data) => {
  return request({
    url: 'sap/bc/ztpm/to_new_crm/transdata/forms014',
    method: 'POST',
    data
  })
}

// 各营销中心品牌销售情况统计报表
export const reportForm15 = (data) => {
  return request({
    url: 'sap/bc/ztpm/to_new_crm/transdata/forms015',
    method: 'POST',
    data
  })
}

// 经销商预估计划量查询报表
export const reportForm16 = (data) => {
  return request({
    url: 'sap/bc/ztpm/to_new_crm/transdata/forms016',
    method: 'POST',
    data
  })
}




// WEBPACK FOOTER //
// ./src/api/sap/report.js